const categories = {
  studio: {
    type: 'studio',
    styleBgColor: function() {
      return `category--${this.type}`;
    },
    styleColor: function(view = 'card') {
      return `${view}-content-header__category--${this.type}`;
    },
    displayName: 'ESTÚDIO',
  },
  vt: {
    type: 'vt',
    styleBgColor: function() {
      return `category--${this.type}`;
    },
    styleColor: function(view = 'card') {
      return `${view}-content-header__category--${this.type}`;
    },
    displayName: 'VT',
  },
  live: {
    type: 'live',
    styleBgColor: function() {
      return `category--${this.type}`;
    },
    styleColor: function(view = 'card') {
      return `${view}-content-header__category--${this.type}`;
    },
    displayName: 'AO VIVO',
  },
  screen: {
    type: 'screen',
    styleBgColor: function() {
      return `category--${this.type}`;
    },
    styleColor: function(view = 'card') {
      return `${view}-content-header__category--${this.type}`;
    },
    displayName: 'TELÃO',
  },
  others: {
    type: 'others',
    styleBgColor: function() {
      return `category--${this.type}`;
    },
    styleColor: function(view = 'card') {
      return `${view}-content-header__category--${this.type}`;
    },
    displayName: 'OUTROS',
  },
};

const textColorClassFromType = (view, type) =>
  categories[type].styleColor(view);

const bgColorClassCategoryType = type => categories[type].styleBgColor();

const itemTypeDisplay = type => categories[type].displayName;

const normalizeType = rawType => {
  if (!rawType) return categories.others.type;

  const normalizedType = rawType
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  if (normalizedType.includes('estudio')) return categories.studio.type;
  if (normalizedType.includes('vt')) return categories.vt.type;
  if (normalizedType.includes('vivo')) return categories.live.type;
  if (normalizedType.includes('telao')) return categories.screen.type;

  return categories.others.type;
};

const formatField = value => {
  return !value || !value.trim() || value.includes('=') ? '--' : value;
};

export {
  categories,
  itemTypeDisplay,
  normalizeType,
  formatField,
  bgColorClassCategoryType,
  textColorClassFromType,
};
